<boi-mortgage-app-section-navigation #boiTabWrapper (detectChanges)="changeDetectorRef.detectChanges()">
    <div class="title-bar">
        <h1 class="title-bar-text vo-heading-regular-22">{{referenceDataLabels.SectionTitleMortgage | localizeLabel}}</h1>
        <span class="required-label vo-body-regular-14 vo-display-none" [innerHtml]="referenceDataLabels.MandatoryFields | localizeLabel"></span>
    </div>
    <boi-form-information-box [message]="referenceDataLabels.MortgageDescription"></boi-form-information-box>

    <boi-accordion>
        <boi-accordion-item #accordionItem1 [title]="referenceDataLabels.AboutTheMortgageId | localizeLabel"
            [class]="'js-section-' + referenceDataLabels.AboutTheMortgageId | removeWhiteSpaces"
            [data]="sections.YourMortgage.AboutYourMortgage">
            <boi-progress-stepper-item header [status]="sections.YourMortgage.AboutYourMortgage"
                [hasSubmitValidationError]="hasSubmitValidationError">
            </boi-progress-stepper-item>
            <boi-about-the-mortgage [(isFeeUpToDate)]="isFeeUpToDate"></boi-about-the-mortgage>
            <boi-save-application class="buttons__bar" [saveButtonLabel]="!mortgageApplication?.IsFactFind ?
                saveContinueButtonLabel :
                saveContinueToNextStepButtonLabel"
                [hideActionButton]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)"
                (cancel)="boiTabWrapper.goToSection(referenceDataLabels.AboutTheMortgageId)"
                (save)="boiTabWrapper.goToNextIncompleted(accordionItem1); isFeeUpToDate = true">
            </boi-save-application>
        </boi-accordion-item>
        <div class="vo-separator-line my-15"></div>
        <boi-accordion-item #accordionItem2 *ngIf="!mortgageApplication?.IsFactFind"
            [title]="referenceDataLabels.AboutTheFeesId | localizeLabel"
            [class]="'js-section-' + referenceDataLabels.AboutTheFeesId | removeWhiteSpaces"
            [data]="sections.YourMortgage.AboutYourMortgage">
            <boi-progress-stepper-item header [status]="sections.YourMortgage.AboutTheFees"
                [hasSubmitValidationError]="hasSubmitValidationError">
            </boi-progress-stepper-item>
            <div class="bo-info-text" [innerHTML]="referenceDataLabels.AboutTheFeesDetails | localizeLabel"></div>
            <boi-fees [application]="mortgageApplication" [isFeeUpToDate]="isFeeUpToDate" [shouldHideIsRecommendedCode]="shouldHideIsRecommendedCode"></boi-fees>
            <boi-save-application class="buttons__bar" [saveButtonLabel]="saveContinueToNextStepButtonLabel"
                [hideActionButton]="mortgageApplication?.IsApplicationReadOnly"
                (cancel)="boiTabWrapper.goToSection(referenceDataLabels.AboutTheFeesId)"
                (save)="boiTabWrapper.goToNextIncompleted(accordionItem2)"></boi-save-application>
        </boi-accordion-item>
    </boi-accordion>
</boi-mortgage-app-section-navigation>
